<template>
    <transition :name="currentTransition" @after-enter="afterEnter" @before-enter="beforeEnter"
                @after-leave="afterLeave">
        <div ref="popup" class="custom-popup" v-if="show" :style="{zIndex:zIndex}" :class="[position]">
            <slot/>
        </div>
    </transition>
</template>

<script>
	import modal from './modal';

	const Modal = new modal();

	export default {
		name: 'popup',
		props: {
			// 是否动画
			transition: String,
			// 是否开启遮盖层
			overlay: {
				type: Boolean,
				default: true
			},
			// 是否点击关闭遮盖层
			closeOnClickOverlay: {
				type: Boolean,
				default: true
			},
			// 弹出位置
			position: {
				type: String,
				default: 'bottom'
			},
			// 是否展示
			show: {
				type: Boolean,
				default: false
			},
			// 是否单独的关闭处理（不随着modal关闭而关闭）
			aloneClose: {
				type: Boolean,
				default: false
			}
		},
		created() {
			// 监听关闭事件
			Modal.onClose(() => {
				this.aloneClose || this.close();
			})

			// 监听浮层点击
			Modal.onOverlayClick((zIndex, context) => {
                // 检查当前的弹窗是否在最前面，并且是不展示浮层的,并且点击关闭弹窗
				if((zIndex + 1) == this.zIndex && !this.overlay && this.closeOnClickOverlay){
					this.close();
                }
			})
		},
		model: {
			prop: 'show',
			event: 'show'
		},
		data() {
			// 初始化点击是否关闭弹窗
			Modal.closeOnClickOverlay(this.closeOnClickOverlay)
			return {
				zIndex: 1001,
				innerShow: false,
			}
		},
		computed: {
			currentTransition() {
				return this.transition || (this.position === '' ? 'fade' : `popup-slide-${this.position}`);
			}
		},
		methods: {
			// 关闭遮盖层
			close() {
				this.$emit('show', false)
				this.$emit('open', {
					value: false,
					zIndex: this.zIndex
				})
			},
			// 进入动画处理之前
			beforeEnter() {

			},
			// 进入动画处理之后
			afterEnter() {
				// 仅做渲染性能优化
				setTimeout(() => {
					this.$emit('after-open', {
						value: true,
						zIndex: this.zIndex
					})
				}, 10)
			},
			// 离开动画之后
			afterLeave() {
				// 仅做渲染性能优化
				setTimeout(() => {
					this.$emit('after-close', {
						value: false,
						zIndex: this.zIndex
					})
				}, 10)
			}
		},
		watch: {
			show(val) {
				requestAnimationFrame(() => {
					if (val) {
						this.$emit('open', {
							value: true,
							zIndex: this.zIndex
						})
						Modal.open(this.$refs.popup.parentNode, zIndex => this.zIndex = zIndex, !this.overlay);
					} else {
						Modal.close(!this.overlay)
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
    .custom-popup {
        position: fixed;
        top: 50%;
        left: 50%;
        max-height: 100%;
        overflow-y: auto;
        transition: .35s ease-out !important;
        -webkit-overflow-scrolling: touch !important;
        transform: translate3d(-50%, -50%, 0) !important;
        &.top {
            width: 100%;
            top: 30%;
            right: auto;
            bottom: auto;
            left: 50%;
            transform: translate3d(-50%, 0, 0) !important;
        }

        &.right {
            top: 50%;
            right: 0;
            bottom: auto;
            left: auto;
            transform: translate3d(0, -50%, 0) !important;
        }

        &.bottom {
            width: 100%;
            top: auto;
            bottom: 0;
            right: auto;
            left: 50%;
            transform: translate3d(-50%, 0, 0) !important;
        }

        &.left {
            top: 0;
            right: auto;
            bottom: auto;
            left: 0;
            transform: translate3d(0, 0%, 0) !important;
        }

        &.popup-slide-top-enter,
        &.popup-slide-top-leave-active {
            transform: translate3d(-50%, -100%, 0) !important;
        }

        &.popup-slide-right-enter,
        &.popup-slide-right-leave-active {
            transform: translate3d(100%, -50%, 0) !important;
        }

        &.popup-slide-bottom-enter,
        &.popup-slide-bottom-leave-active {
            transform: translate3d(-50%, 100%, 0) !important;
        }

        &.popup-slide-left-enter,
        &.popup-slide-left-leave-active {
            transform: translate3d(-100%, 0%, 0) !important;
        }
    }


</style>